import React from "react";

import { Preview, TextState } from "@creatomate/preview";
import { Button } from "@culturehq/components";

import { ElementSource } from "chq";
import { Trans } from "app/utils";
import ChqModalConfirmDelete from "components/common/ChqModalConfirmDelete";
import { isSubtitleText, updateSubtitleIndexes } from "../utils";

interface DeleteSectionProps {
  preview: Preview;
  subtitleElement: TextState;
}

const DeleteSection: React.FC<DeleteSectionProps> = ({ preview, subtitleElement }) => {
  const handleAccept = async () => {
    const source = preview.getSource();

    const noSubtitleElements = source.elements.filter((element: ElementSource) => (
      !isSubtitleText(element.name)
    ));

    const elementName = subtitleElement.source.name;
    const [prefix, index] = elementName.split("-", 2);
    const allSubtitleElements = source.elements.filter((element: ElementSource) => {
      const [otherPrefix, otherIndex] = element.name?.split("-", 2) || [];
      return isSubtitleText(element.name) && !(otherPrefix === prefix && otherIndex === index);
    });

    const reindexedElements = updateSubtitleIndexes(allSubtitleElements);

    await preview.setSource({
      ...source,
      elements: [
        ...noSubtitleElements,
        ...reindexedElements
      ]
    }, true);
  };

  return (
    <ChqModalConfirmDelete
      onAccept={handleAccept}
      trigger={(onTrigger: () => void) => (
        <Button className="DeleteBtn" icon="trash-a-outlined" onClick={onTrigger} inverted />
      )}
    >
      <Trans>Are you sure you would like to delete this section?</Trans>
    </ChqModalConfirmDelete>
  );
};

export default DeleteSection;
